import Image from 'next/image'

import Flex from '@totallymoney/ui/components/Flex'

import backgroundRough04 from '@images/background-texture-rough-04.png'

const UnscoredCategoryPageBackgroundTextureReviewsSection = () => (
    <Flex justifyContent="center" aria-hidden="true">
        <Image
            src={backgroundRough04}
            alt=""
            placeholder="empty"
            sizes="100vw"
            quality={60}
            priority={false}
        />
    </Flex>
)

export default UnscoredCategoryPageBackgroundTextureReviewsSection
